import {
  Button,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  DialogContentText,
  Backdrop,
  Box,
  Portal,
} from '@mui/material'
import Draggable from 'react-draggable'

export interface InformationPopupProps {
  setOpenInformationPopup: (value: boolean) => void
  openInformationPopup: boolean
  informationMessage: string
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onSubmit: (input?: any) => void
  contentText?: string
}

export function InformationPopup({
  setOpenInformationPopup,
  openInformationPopup,
  informationMessage,
  onSubmit,
  contentText,
}: InformationPopupProps) {
  const handleChange = () => {
    setOpenInformationPopup(false)
  }

  return (
    <Box style={{ position: 'relative' }}>
      <Portal>
        <Backdrop
          open={openInformationPopup}
          style={{ zIndex: 1300, position: 'fixed' }}
        />
      </Portal>
      <Draggable>
        <Dialog
          fullWidth
          maxWidth='sm'
          hideBackdrop={true}
          open={openInformationPopup}
          PaperProps={{
            sx: { maxWidth: 'none', width: '70%' },
          }}
        >
          <DialogTitle sx={{ pt: 5 }}>{contentText}</DialogTitle>
          <DialogContent dividers>
            <DialogContentText sx={{ my: 2 }}>
              {informationMessage}
            </DialogContentText>
            <DialogActions sx={{ mt: 4, px: 0 }}>
              <Button
                variant='contained'
                onClick={() => onSubmit()}
                sx={{ mr: 2 }}
              >
                Vista
              </Button>
              <Button
                variant='contained'
                color='secondary'
                onClick={() => handleChange()}
              >
                Til Baka
              </Button>
            </DialogActions>
          </DialogContent>
        </Dialog>
      </Draggable>
    </Box>
  )
}
